export default __webpack_public_path__ + "static/media/home.782c1390.svg";